import { TableWarningRegion } from 'components-modules/tables/table-forecast-waterActivity/water-activity-entry.js';
import { useAppSelector } from 'redux-state/configure-store.js';
import { ILocationWarningState, ILocationWarningType } from 'redux-state/weather-warnings/types.js';
import { getLoadedLocationWarnings } from 'utilities/weather-warnings/warnings.js';

/** Get loaded warnings for location */
export const LoadedWarningsByLocationHook = ({
  locationOverride,
  warningsFilter,
  warningRegionOverride,
}: {
  warningRegionOverride?: TableWarningRegion['warningRegion'];
  locationOverride?: Partial<ILocationWarningType>;
  warningsFilter?: boolean;
} = {}): Readonly<ILocationWarningState> | undefined => {
  const weatherWarnings = useAppSelector((state) => state.WEATHER_WARNINGS);
  const stateLocation = useAppSelector((state) => state.LAYOUT.screen.location);
  const location = locationOverride || stateLocation;
  const warningsForLoc = getLoadedLocationWarnings(location ?? {}, weatherWarnings.warnings);
  const locationRegion =
    warningRegionOverride ?? (location && 'websiteRegion' in location ? location.websiteRegion : undefined);
  if (warningsFilter && warningsForLoc && locationRegion) {
    const filteredWarnings = warningsForLoc.warnings?.filter((w) => {
      const warningRegions = (w.regions ?? []).map((a) => `${a}`);
      const filteredWarnings = warningRegions?.includes(locationRegion);
      return filteredWarnings;
    });
    const result: Readonly<ILocationWarningState> = { ...warningsForLoc, warnings: filteredWarnings };
    return result;
  }

  return warningsForLoc;
};
